export default "__VITE_ASSET__BTgtF7US__"